import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { SORT_DIRECTION } from "../../../utils/vars";

export const ADVANCED_SEARCH_HISTORY_REDUCER_NAME = "advanced-search-history";

const initialState = {
  page: 0,
  take: 20,
  totalCount: 0,
  sort: {
    direction: SORT_DIRECTION.DESC,
    type: "DATE",
  },
  data: [],
  filters: {
    author: "",
    ruleName: "",
    startDate: "",
    endDate: "",
    exactDate: "",
    q: "",
  },
};

const advancedSearchHistorySlice = createSlice({
  name: ADVANCED_SEARCH_HISTORY_REDUCER_NAME,
  initialState,
  reducers: {
    setAdvancedSearchHistoryData: (state, { payload }) => {
      state.data = [...payload];
    },
    setAdvancedSearchHistoryPage: (state, { payload }) => {
      state.page = payload;
    },
    setAdvancedSearchHistoryTake: (state, { payload }) => {
      state.take = payload;
    },
    setAdvancedSearchHistoryTotalCount: (state, { payload }) => {
      state.totalCount = payload;
    },
    setAdvancedSearchHistoryFilters: (state, { payload }) => {
      const temp = { ...state.filters };
      state.filters = { ...temp, ...payload };
    },
    setAdvancedSearchHistorySort: (state, { payload }) => {
      state.sort = payload;
    },
    clearAdvancedSearchHistory: (state) => {
      state.page = initialState.page;
      state.take = initialState.take;
      state.totalCount = initialState.totalCount;
      state.sort = initialState.sort;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
  },
});

export const {
  clearAdvancedSearchHistory,
  setAdvancedSearchHistoryData,
  setAdvancedSearchHistoryPage,
  setAdvancedSearchHistoryTake,
  setAdvancedSearchHistoryTotalCount,
  setAdvancedSearchHistoryFilters,
  setAdvancedSearchHistorySort,
} = advancedSearchHistorySlice.actions;

export default advancedSearchHistorySlice.reducer;

export const useSelectPageAdvancedSearchHistory = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].page,
  );
};

export const useSelectTakeAdvancedSearchHistory = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].take,
  );
};

export const useSelectAdvancedSearchHistoryData = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].data,
  );
};

export const useSelectTotalCountAdvancedSearchHistory = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].totalCount,
  );
};

export const useSelectFiltersAdvancedSearchHistory = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].filters,
  );
};

export const useSelectSortAdvancedSearchHistory = () => {
  return useSelector(
    (state) => state[ADVANCED_SEARCH_HISTORY_REDUCER_NAME].sort,
  );
};
